import Header from "./Header";
import About from "./About";
import Contact from "./Contact";
import Footer from "./Footer";
import {  BrowserRouter as Router,Route,Routes } from "react-router-dom";
import Home from "./Home";
import Projects from "./Projects";
import { useEffect, useState } from "react";
function App() {
  let [data,setData] =useState([
    {
        "id":0,
        "img":"/mem.jpg",
        "title":"Memory Game",
        "url":"https://joememory.netlify.app/",
        "lang":["html","css","js"]
    },
    {
        "id":1,
        "img":"/todo.jpg",
        "title":"To Do List CURD",
        "url":"https://joetodolist.netlify.app/",
        "lang":["html","css","react","node"]
    },
    {
        "id":2,
        "img":"/crack.jpg",
        "title":"Password Cracker Game",
        "url":"https://joecrackcode.netlify.app/",
        "lang":["html","css","js"]
    }
  ]);
  useEffect(()=>{
//     try{
//       async function demo() {

//       let res = await fetch("http://localhost:3001/api");
//     let data = await res.json();
//   // if(!data) throw res.er;
// setData(data);
// }
// demo();
// }catch(err){
// console.log(err);
// }
  },[])
  let shortData = [];
  let short = ()=> {
    for (let i = 0; i < 3; i++) {
      shortData.push(data[i])
      
    }
  }
  short();
  let [showMenu,setShowMenu] = useState(false);
  return (
    <Router>

    <div className="App">

    <Header
    showMenu={showMenu}
    setShowMenu={setShowMenu}
    />
    <div  onClick={()=>setShowMenu(false)}>

    <Routes>
    <Route exact path="/" Component={()=><Home data={shortData}/>}/>
    <Route exact path="/about" Component={()=><About/>}/>
    <Route exact path="/contact" Component={()=><Contact/>}/>
    <Route exact path="/projects" Component={()=><Projects data={data}/>}/>
      
    
    {/* <Contact/> */}
    </Routes>
    </div>
    <Footer/>
    </div>
    </Router>
  );
}

export default App;
